// extracted by mini-css-extract-plugin
module.exports = {"page":"efdelta-discharge-information_page__eSVTC"};